import * as i from "valibot";
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function an(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n of e.split(",")) t[n] = 1;
  return (n) => n in t;
}
const ze = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, un = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], ht = () => {
}, fn = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), F = Object.assign, pn = Object.prototype.hasOwnProperty, $e = (e, t) => pn.call(e, t), _ = Array.isArray, q = (e) => Ce(e) === "[object Map]", dn = (e) => Ce(e) === "[object Set]", x = (e) => typeof e == "function", S = (e) => typeof e == "string", H = (e) => typeof e == "symbol", E = (e) => e !== null && typeof e == "object", mt = Object.prototype.toString, Ce = (e) => mt.call(e), gt = (e) => Ce(e).slice(8, -1), hn = (e) => Ce(e) === "[object Object]", Be = (e) => S(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, _t = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, mn = /-(\w)/g, he = _t(
  (e) => e.replace(mn, (t, n) => n ? n.toUpperCase() : "")
), me = _t((e) => e.charAt(0).toUpperCase() + e.slice(1)), te = (e, t) => !Object.is(e, t);
let rt;
const Ee = () => rt || (rt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function we(e) {
  if (_(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const o = e[n], s = S(o) ? yn(o) : we(o);
      if (s)
        for (const r in s)
          t[r] = s[r];
    }
    return t;
  } else if (S(e) || E(e))
    return e;
}
const gn = /;(?![^(]*\))/g, _n = /:([^]+)/, bn = /\/\*[^]*?\*\//g;
function yn(e) {
  const t = {};
  return e.replace(bn, "").split(gn).forEach((n) => {
    if (n) {
      const o = n.split(_n);
      o.length > 1 && (t[o[0].trim()] = o[1].trim());
    }
  }), t;
}
function A(e) {
  let t = "";
  if (S(e))
    t = e;
  else if (_(e))
    for (let n = 0; n < e.length; n++) {
      const o = A(e[n]);
      o && (t += o + " ");
    }
  else if (E(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
function it(e) {
  if (!e) return null;
  let { class: t, style: n } = e;
  return t && !S(t) && (e.class = A(t)), n && (e.style = we(n)), e;
}
const bt = (e) => !!(e && e.__v_isRef === !0), Ae = (e) => S(e) ? e : e == null ? "" : _(e) || E(e) && (e.toString === mt || !x(e.toString)) ? bt(e) ? Ae(e.value) : JSON.stringify(e, yt, 2) : String(e), yt = (e, t) => bt(t) ? yt(e, t.value) : q(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce(
    (n, [o, s], r) => (n[Te(o, r) + " =>"] = s, n),
    {}
  )
} : dn(t) ? {
  [`Set(${t.size})`]: [...t.values()].map((n) => Te(n))
} : H(t) ? Te(t) : E(t) && !_(t) && !hn(t) ? String(t) : t, Te = (e, t = "") => {
  var n;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    H(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e
  );
};
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function G(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let m, vt = 0, ne, se;
function vn(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = se, se = e;
    return;
  }
  e.next = ne, ne = e;
}
function Ye() {
  vt++;
}
function qe() {
  if (--vt > 0)
    return;
  if (se) {
    let t = se;
    for (se = void 0; t; ) {
      const n = t.next;
      t.next = void 0, t.flags &= -9, t = n;
    }
  }
  let e;
  for (; ne; ) {
    let t = ne;
    for (ne = void 0; t; ) {
      const n = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (o) {
          e || (e = o);
        }
      t = n;
    }
  }
  if (e) throw e;
}
function Cn(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function En(e) {
  let t, n = e.depsTail, o = n;
  for (; o; ) {
    const s = o.prevDep;
    o.version === -1 ? (o === n && (n = s), Et(o), Nn(o)) : t = o, o.dep.activeLink = o.prevActiveLink, o.prevActiveLink = void 0, o = s;
  }
  e.deps = t, e.depsTail = n;
}
function wn(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (Ct(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function Ct(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === re))
    return;
  e.globalVersion = re;
  const t = e.dep;
  if (e.flags |= 2, t.version > 0 && !e.isSSR && e.deps && !wn(e)) {
    e.flags &= -3;
    return;
  }
  const n = m, o = M;
  m = e, M = !0;
  try {
    Cn(e);
    const s = e.fn(e._value);
    (t.version === 0 || te(s, e._value)) && (e._value = s, t.version++);
  } catch (s) {
    throw t.version++, s;
  } finally {
    m = n, M = o, En(e), e.flags &= -3;
  }
}
function Et(e, t = !1) {
  const { dep: n, prevSub: o, nextSub: s } = e;
  if (o && (o.nextSub = s, e.prevSub = void 0), s && (s.prevSub = o, e.nextSub = void 0), process.env.NODE_ENV !== "production" && n.subsHead === e && (n.subsHead = s), n.subs === e && (n.subs = o, !o && n.computed)) {
    n.computed.flags &= -5;
    for (let r = n.computed.deps; r; r = r.nextDep)
      Et(r, !0);
  }
  !t && !--n.sc && n.map && n.map.delete(n.key);
}
function Nn(e) {
  const { prevDep: t, nextDep: n } = e;
  t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
let M = !0;
const wt = [];
function Je() {
  wt.push(M), M = !1;
}
function Ge() {
  const e = wt.pop();
  M = e === void 0 ? !0 : e;
}
let re = 0;
class Sn {
  constructor(t, n) {
    this.sub = t, this.dep = n, this.version = n.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class Nt {
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
  }
  track(t) {
    if (!m || !M || m === this.computed)
      return;
    let n = this.activeLink;
    if (n === void 0 || n.sub !== m)
      n = this.activeLink = new Sn(m, this), m.deps ? (n.prevDep = m.depsTail, m.depsTail.nextDep = n, m.depsTail = n) : m.deps = m.depsTail = n, St(n);
    else if (n.version === -1 && (n.version = this.version, n.nextDep)) {
      const o = n.nextDep;
      o.prevDep = n.prevDep, n.prevDep && (n.prevDep.nextDep = o), n.prevDep = m.depsTail, n.nextDep = void 0, m.depsTail.nextDep = n, m.depsTail = n, m.deps === n && (m.deps = o);
    }
    return process.env.NODE_ENV !== "production" && m.onTrack && m.onTrack(
      F(
        {
          effect: m
        },
        t
      )
    ), n;
  }
  trigger(t) {
    this.version++, re++, this.notify(t);
  }
  notify(t) {
    Ye();
    try {
      if (process.env.NODE_ENV !== "production")
        for (let n = this.subsHead; n; n = n.nextSub)
          n.sub.onTrigger && !(n.sub.flags & 8) && n.sub.onTrigger(
            F(
              {
                effect: n.sub
              },
              t
            )
          );
      for (let n = this.subs; n; n = n.prevSub)
        n.sub.notify() && n.sub.dep.notify();
    } finally {
      qe();
    }
  }
}
function St(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let o = t.deps; o; o = o.nextDep)
        St(o);
    }
    const n = e.dep.subs;
    n !== e && (e.prevSub = n, n && (n.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
  }
}
const Me = /* @__PURE__ */ new WeakMap(), K = Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
), Pe = Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
), ie = Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
function v(e, t, n) {
  if (M && m) {
    let o = Me.get(e);
    o || Me.set(e, o = /* @__PURE__ */ new Map());
    let s = o.get(n);
    s || (o.set(n, s = new Nt()), s.map = o, s.key = n), process.env.NODE_ENV !== "production" ? s.track({
      target: e,
      type: t,
      key: n
    }) : s.track();
  }
}
function z(e, t, n, o, s, r) {
  const c = Me.get(e);
  if (!c) {
    re++;
    return;
  }
  const l = (a) => {
    a && (process.env.NODE_ENV !== "production" ? a.trigger({
      target: e,
      type: t,
      key: n,
      newValue: o,
      oldValue: s,
      oldTarget: r
    }) : a.trigger());
  };
  if (Ye(), t === "clear")
    c.forEach(l);
  else {
    const a = _(e), f = a && Be(n);
    if (a && n === "length") {
      const p = Number(o);
      c.forEach((u, d) => {
        (d === "length" || d === ie || !H(d) && d >= p) && l(u);
      });
    } else
      switch ((n !== void 0 || c.has(void 0)) && l(c.get(n)), f && l(c.get(ie)), t) {
        case "add":
          a ? f && l(c.get("length")) : (l(c.get(K)), q(e) && l(c.get(Pe)));
          break;
        case "delete":
          a || (l(c.get(K)), q(e) && l(c.get(Pe)));
          break;
        case "set":
          q(e) && l(c.get(K));
          break;
      }
  }
  qe();
}
function B(e) {
  const t = h(e);
  return t === e ? t : (v(t, "iterate", ie), O(e) ? t : t.map(C));
}
function Ne(e) {
  return v(e = h(e), "iterate", ie), e;
}
const Dn = {
  __proto__: null,
  [Symbol.iterator]() {
    return Ve(this, Symbol.iterator, C);
  },
  concat(...e) {
    return B(this).concat(
      ...e.map((t) => _(t) ? B(t) : t)
    );
  },
  entries() {
    return Ve(this, "entries", (e) => (e[1] = C(e[1]), e));
  },
  every(e, t) {
    return k(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return k(this, "filter", e, t, (n) => n.map(C), arguments);
  },
  find(e, t) {
    return k(this, "find", e, t, C, arguments);
  },
  findIndex(e, t) {
    return k(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return k(this, "findLast", e, t, C, arguments);
  },
  findLastIndex(e, t) {
    return k(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return k(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return xe(this, "includes", e);
  },
  indexOf(...e) {
    return xe(this, "indexOf", e);
  },
  join(e) {
    return B(this).join(e);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...e) {
    return xe(this, "lastIndexOf", e);
  },
  map(e, t) {
    return k(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return Q(this, "pop");
  },
  push(...e) {
    return Q(this, "push", e);
  },
  reduce(e, ...t) {
    return ct(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return ct(this, "reduceRight", e, t);
  },
  shift() {
    return Q(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return k(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return Q(this, "splice", e);
  },
  toReversed() {
    return B(this).toReversed();
  },
  toSorted(e) {
    return B(this).toSorted(e);
  },
  toSpliced(...e) {
    return B(this).toSpliced(...e);
  },
  unshift(...e) {
    return Q(this, "unshift", e);
  },
  values() {
    return Ve(this, "values", C);
  }
};
function Ve(e, t, n) {
  const o = Ne(e), s = o[t]();
  return o !== e && !O(e) && (s._next = s.next, s.next = () => {
    const r = s._next();
    return r.value && (r.value = n(r.value)), r;
  }), s;
}
const On = Array.prototype;
function k(e, t, n, o, s, r) {
  const c = Ne(e), l = c !== e && !O(e), a = c[t];
  if (a !== On[t]) {
    const u = a.apply(e, r);
    return l ? C(u) : u;
  }
  let f = n;
  c !== e && (l ? f = function(u, d) {
    return n.call(this, C(u), d, e);
  } : n.length > 2 && (f = function(u, d) {
    return n.call(this, u, d, e);
  }));
  const p = a.call(c, f, o);
  return l && s ? s(p) : p;
}
function ct(e, t, n, o) {
  const s = Ne(e);
  let r = n;
  return s !== e && (O(e) ? n.length > 3 && (r = function(c, l, a) {
    return n.call(this, c, l, a, e);
  }) : r = function(c, l, a) {
    return n.call(this, c, C(l), a, e);
  }), s[t](r, ...o);
}
function xe(e, t, n) {
  const o = h(e);
  v(o, "iterate", ie);
  const s = o[t](...n);
  return (s === -1 || s === !1) && ge(n[0]) ? (n[0] = h(n[0]), o[t](...n)) : s;
}
function Q(e, t, n = []) {
  Je(), Ye();
  const o = h(e)[t].apply(e, n);
  return qe(), Ge(), o;
}
const Rn = /* @__PURE__ */ an("__proto__,__v_isRef,__isVue"), Dt = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(H)
);
function Tn(e) {
  H(e) || (e = String(e));
  const t = h(this);
  return v(t, "has", e), t.hasOwnProperty(e);
}
class Ot {
  constructor(t = !1, n = !1) {
    this._isReadonly = t, this._isShallow = n;
  }
  get(t, n, o) {
    if (n === "__v_skip") return t.__v_skip;
    const s = this._isReadonly, r = this._isShallow;
    if (n === "__v_isReactive")
      return !s;
    if (n === "__v_isReadonly")
      return s;
    if (n === "__v_isShallow")
      return r;
    if (n === "__v_raw")
      return o === (s ? r ? Pn : Vt : r ? Mn : Tt).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(o) ? t : void 0;
    const c = _(t);
    if (!s) {
      let a;
      if (c && (a = Dn[n]))
        return a;
      if (n === "hasOwnProperty")
        return Tn;
    }
    const l = Reflect.get(
      t,
      n,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      P(t) ? t : o
    );
    return (H(n) ? Dt.has(n) : Rn(n)) || (s || v(t, "get", n), r) ? l : P(l) ? c && Be(n) ? l : l.value : E(l) ? s ? kt(l) : xt(l) : l;
  }
}
class Vn extends Ot {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, n, o, s) {
    let r = t[n];
    if (!this._isShallow) {
      const a = L(r);
      if (!O(o) && !L(o) && (r = h(r), o = h(o)), !_(t) && P(r) && !P(o))
        return a ? !1 : (r.value = o, !0);
    }
    const c = _(t) && Be(n) ? Number(n) < t.length : $e(t, n), l = Reflect.set(
      t,
      n,
      o,
      P(t) ? t : s
    );
    return t === h(s) && (c ? te(o, r) && z(t, "set", n, o, r) : z(t, "add", n, o)), l;
  }
  deleteProperty(t, n) {
    const o = $e(t, n), s = t[n], r = Reflect.deleteProperty(t, n);
    return r && o && z(t, "delete", n, void 0, s), r;
  }
  has(t, n) {
    const o = Reflect.has(t, n);
    return (!H(n) || !Dt.has(n)) && v(t, "has", n), o;
  }
  ownKeys(t) {
    return v(
      t,
      "iterate",
      _(t) ? "length" : K
    ), Reflect.ownKeys(t);
  }
}
class xn extends Ot {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, n) {
    return process.env.NODE_ENV !== "production" && G(
      `Set operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
  deleteProperty(t, n) {
    return process.env.NODE_ENV !== "production" && G(
      `Delete operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
}
const kn = /* @__PURE__ */ new Vn(), jn = /* @__PURE__ */ new xn(), Fe = (e) => e, ae = (e) => Reflect.getPrototypeOf(e);
function In(e, t, n) {
  return function(...o) {
    const s = this.__v_raw, r = h(s), c = q(r), l = e === "entries" || e === Symbol.iterator && c, a = e === "keys" && c, f = s[e](...o), p = n ? Fe : t ? Le : C;
    return !t && v(
      r,
      "iterate",
      a ? Pe : K
    ), {
      // iterator protocol
      next() {
        const { value: u, done: d } = f.next();
        return d ? { value: u, done: d } : {
          value: l ? [p(u[0]), p(u[1])] : p(u),
          done: d
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function ue(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const n = t[0] ? `on key "${t[0]}" ` : "";
      G(
        `${me(e)} operation ${n}failed: target is readonly.`,
        h(this)
      );
    }
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function zn(e, t) {
  const n = {
    get(s) {
      const r = this.__v_raw, c = h(r), l = h(s);
      e || (te(s, l) && v(c, "get", s), v(c, "get", l));
      const { has: a } = ae(c), f = t ? Fe : e ? Le : C;
      if (a.call(c, s))
        return f(r.get(s));
      if (a.call(c, l))
        return f(r.get(l));
      r !== c && r.get(s);
    },
    get size() {
      const s = this.__v_raw;
      return !e && v(h(s), "iterate", K), Reflect.get(s, "size", s);
    },
    has(s) {
      const r = this.__v_raw, c = h(r), l = h(s);
      return e || (te(s, l) && v(c, "has", s), v(c, "has", l)), s === l ? r.has(s) : r.has(s) || r.has(l);
    },
    forEach(s, r) {
      const c = this, l = c.__v_raw, a = h(l), f = t ? Fe : e ? Le : C;
      return !e && v(a, "iterate", K), l.forEach((p, u) => s.call(r, f(p), f(u), c));
    }
  };
  return F(
    n,
    e ? {
      add: ue("add"),
      set: ue("set"),
      delete: ue("delete"),
      clear: ue("clear")
    } : {
      add(s) {
        !t && !O(s) && !L(s) && (s = h(s));
        const r = h(this);
        return ae(r).has.call(r, s) || (r.add(s), z(r, "add", s, s)), this;
      },
      set(s, r) {
        !t && !O(r) && !L(r) && (r = h(r));
        const c = h(this), { has: l, get: a } = ae(c);
        let f = l.call(c, s);
        f ? process.env.NODE_ENV !== "production" && lt(c, l, s) : (s = h(s), f = l.call(c, s));
        const p = a.call(c, s);
        return c.set(s, r), f ? te(r, p) && z(c, "set", s, r, p) : z(c, "add", s, r), this;
      },
      delete(s) {
        const r = h(this), { has: c, get: l } = ae(r);
        let a = c.call(r, s);
        a ? process.env.NODE_ENV !== "production" && lt(r, c, s) : (s = h(s), a = c.call(r, s));
        const f = l ? l.call(r, s) : void 0, p = r.delete(s);
        return a && z(r, "delete", s, void 0, f), p;
      },
      clear() {
        const s = h(this), r = s.size !== 0, c = process.env.NODE_ENV !== "production" ? q(s) ? new Map(s) : new Set(s) : void 0, l = s.clear();
        return r && z(
          s,
          "clear",
          void 0,
          void 0,
          c
        ), l;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((s) => {
    n[s] = In(s, e, t);
  }), n;
}
function Rt(e, t) {
  const n = zn(e, t);
  return (o, s, r) => s === "__v_isReactive" ? !e : s === "__v_isReadonly" ? e : s === "__v_raw" ? o : Reflect.get(
    $e(n, s) && s in o ? n : o,
    s,
    r
  );
}
const $n = {
  get: /* @__PURE__ */ Rt(!1, !1)
}, An = {
  get: /* @__PURE__ */ Rt(!0, !1)
};
function lt(e, t, n) {
  const o = h(n);
  if (o !== n && t.call(e, o)) {
    const s = gt(e);
    G(
      `Reactive ${s} contains both the raw and reactive versions of the same object${s === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const Tt = /* @__PURE__ */ new WeakMap(), Mn = /* @__PURE__ */ new WeakMap(), Vt = /* @__PURE__ */ new WeakMap(), Pn = /* @__PURE__ */ new WeakMap();
function Fn(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function Ln(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : Fn(gt(e));
}
function xt(e) {
  return L(e) ? e : jt(
    e,
    !1,
    kn,
    $n,
    Tt
  );
}
function kt(e) {
  return jt(
    e,
    !0,
    jn,
    An,
    Vt
  );
}
function jt(e, t, n, o, s) {
  if (!E(e))
    return process.env.NODE_ENV !== "production" && G(
      `value cannot be made ${t ? "readonly" : "reactive"}: ${String(
        e
      )}`
    ), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const r = s.get(e);
  if (r)
    return r;
  const c = Ln(e);
  if (c === 0)
    return e;
  const l = new Proxy(
    e,
    c === 2 ? o : n
  );
  return s.set(e, l), l;
}
function Xe(e) {
  return L(e) ? Xe(e.__v_raw) : !!(e && e.__v_isReactive);
}
function L(e) {
  return !!(e && e.__v_isReadonly);
}
function O(e) {
  return !!(e && e.__v_isShallow);
}
function ge(e) {
  return e ? !!e.__v_raw : !1;
}
function h(e) {
  const t = e && e.__v_raw;
  return t ? h(t) : e;
}
const C = (e) => E(e) ? xt(e) : e, Le = (e) => E(e) ? kt(e) : e;
function P(e) {
  return e ? e.__v_isRef === !0 : !1;
}
class Hn {
  constructor(t, n, o) {
    this.fn = t, this.setter = n, this._value = void 0, this.dep = new Nt(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = re - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !n, this.isSSR = o;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    m !== this)
      return vn(this, !0), !0;
    process.env.NODE_ENV;
  }
  get value() {
    const t = process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track();
    return Ct(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter ? this.setter(t) : process.env.NODE_ENV !== "production" && G("Write operation failed: computed value is readonly");
  }
}
function Kn(e, t, n = !1) {
  let o, s;
  x(e) ? o = e : (o = e.get, s = e.set);
  const r = new Hn(o, s, n);
  return process.env.NODE_ENV, r;
}
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const W = [];
function Wn(e) {
  W.push(e);
}
function Un() {
  W.pop();
}
let ke = !1;
function V(e, ...t) {
  if (ke) return;
  ke = !0, Je();
  const n = W.length ? W[W.length - 1].component : null, o = n && n.appContext.config.warnHandler, s = Bn();
  if (o)
    Qe(
      o,
      n,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((r) => {
          var c, l;
          return (l = (c = r.toString) == null ? void 0 : c.call(r)) != null ? l : JSON.stringify(r);
        }).join(""),
        n && n.proxy,
        s.map(
          ({ vnode: r }) => `at <${sn(n, r.type)}>`
        ).join(`
`),
        s
      ]
    );
  else {
    const r = [`[Vue warn]: ${e}`, ...t];
    s.length && r.push(`
`, ...Yn(s)), console.warn(...r);
  }
  Ge(), ke = !1;
}
function Bn() {
  let e = W[W.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const n = t[0];
    n && n.vnode === e ? n.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const o = e.component && e.component.parent;
    e = o && o.vnode;
  }
  return t;
}
function Yn(e) {
  const t = [];
  return e.forEach((n, o) => {
    t.push(...o === 0 ? [] : [`
`], ...qn(n));
  }), t;
}
function qn({ vnode: e, recurseCount: t }) {
  const n = t > 0 ? `... (${t} recursive calls)` : "", o = e.component ? e.component.parent == null : !1, s = ` at <${sn(
    e.component,
    e.type,
    o
  )}`, r = ">" + n;
  return e.props ? [s, ...Jn(e.props), r] : [s + r];
}
function Jn(e) {
  const t = [], n = Object.keys(e);
  return n.slice(0, 3).forEach((o) => {
    t.push(...It(o, e[o]));
  }), n.length > 3 && t.push(" ..."), t;
}
function It(e, t, n) {
  return S(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : P(t) ? (t = It(e, h(t.value), !0), n ? t : [`${e}=Ref<`, t, ">"]) : x(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = h(t), n ? t : [`${e}=`, t]);
}
const zt = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function Qe(e, t, n, o) {
  try {
    return o ? e(...o) : e();
  } catch (s) {
    $t(s, t, n);
  }
}
function $t(e, t, n, o = !0) {
  const s = t ? t.vnode : null, { errorHandler: r, throwUnhandledErrorInProduction: c } = t && t.appContext.config || ze;
  if (t) {
    let l = t.parent;
    const a = t.proxy, f = process.env.NODE_ENV !== "production" ? zt[n] : `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; l; ) {
      const p = l.ec;
      if (p) {
        for (let u = 0; u < p.length; u++)
          if (p[u](e, a, f) === !1)
            return;
      }
      l = l.parent;
    }
    if (r) {
      Je(), Qe(r, null, 10, [
        e,
        a,
        f
      ]), Ge();
      return;
    }
  }
  Gn(e, n, s, o, c);
}
function Gn(e, t, n, o = !0, s = !1) {
  if (process.env.NODE_ENV !== "production") {
    const r = zt[t];
    if (n && Wn(n), V(`Unhandled error${r ? ` during execution of ${r}` : ""}`), n && Un(), o)
      throw e;
    console.error(e);
  } else {
    if (s)
      throw e;
    console.error(e);
  }
}
const D = [];
let j = -1;
const J = [];
let I = null, Y = 0;
const Xn = /* @__PURE__ */ Promise.resolve();
let He = null;
const Qn = 100;
function Zn(e) {
  let t = j + 1, n = D.length;
  for (; t < n; ) {
    const o = t + n >>> 1, s = D[o], r = ce(s);
    r < e || r === e && s.flags & 2 ? t = o + 1 : n = o;
  }
  return t;
}
function es(e) {
  if (!(e.flags & 1)) {
    const t = ce(e), n = D[D.length - 1];
    !n || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= ce(n) ? D.push(e) : D.splice(Zn(t), 0, e), e.flags |= 1, At();
  }
}
function At() {
  He || (He = Xn.then(Mt));
}
function ts(e) {
  _(e) ? J.push(...e) : I && e.id === -1 ? I.splice(Y + 1, 0, e) : e.flags & 1 || (J.push(e), e.flags |= 1), At();
}
function ns(e) {
  if (J.length) {
    const t = [...new Set(J)].sort(
      (n, o) => ce(n) - ce(o)
    );
    if (J.length = 0, I) {
      I.push(...t);
      return;
    }
    for (I = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), Y = 0; Y < I.length; Y++) {
      const n = I[Y];
      process.env.NODE_ENV !== "production" && Pt(e, n) || (n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), n.flags &= -2);
    }
    I = null, Y = 0;
  }
}
const ce = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function Mt(e) {
  process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map());
  const t = process.env.NODE_ENV !== "production" ? (n) => Pt(e, n) : ht;
  try {
    for (j = 0; j < D.length; j++) {
      const n = D[j];
      if (n && !(n.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && t(n))
          continue;
        n.flags & 4 && (n.flags &= -2), Qe(
          n,
          n.i,
          n.i ? 15 : 14
        ), n.flags & 4 || (n.flags &= -2);
      }
    }
  } finally {
    for (; j < D.length; j++) {
      const n = D[j];
      n && (n.flags &= -2);
    }
    j = -1, D.length = 0, ns(e), He = null, (D.length || J.length) && Mt(e);
  }
}
function Pt(e, t) {
  const n = e.get(t) || 0;
  if (n > Qn) {
    const o = t.i, s = o && tt(o.type);
    return $t(
      `Maximum recursive updates exceeded${s ? ` in component <${s}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return e.set(t, n + 1), !1;
}
const je = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (Ee().__VUE_HMR_RUNTIME__ = {
  createRecord: Ie(ss),
  rerender: Ie(os),
  reload: Ie(rs)
});
const _e = /* @__PURE__ */ new Map();
function ss(e, t) {
  return _e.has(e) ? !1 : (_e.set(e, {
    initialDef: be(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function be(e) {
  return on(e) ? e.__vccOpts : e;
}
function os(e, t) {
  const n = _e.get(e);
  n && (n.initialDef.render = t, [...n.instances].forEach((o) => {
    t && (o.render = t, be(o.type).render = t), o.renderCache = [], o.update();
  }));
}
function rs(e, t) {
  const n = _e.get(e);
  if (!n) return;
  t = be(t), at(n.initialDef, t);
  const o = [...n.instances];
  for (let s = 0; s < o.length; s++) {
    const r = o[s], c = be(r.type);
    let l = je.get(c);
    l || (c !== n.initialDef && at(c, t), je.set(c, l = /* @__PURE__ */ new Set())), l.add(r), r.appContext.propsCache.delete(r.type), r.appContext.emitsCache.delete(r.type), r.appContext.optionsCache.delete(r.type), r.ceReload ? (l.add(r), r.ceReload(t.styles), l.delete(r)) : r.parent ? es(() => {
      r.parent.update(), l.delete(r);
    }) : r.appContext.reload ? r.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), r.root.ce && r !== r.root && r.root.ce._removeChildStyle(c);
  }
  ts(() => {
    je.clear();
  });
}
function at(e, t) {
  F(e, t);
  for (const n in e)
    n !== "__file" && !(n in t) && delete e[n];
}
function Ie(e) {
  return (t, n) => {
    try {
      return e(t, n);
    } catch (o) {
      console.error(o), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let $, Z = [], Ke = !1;
function is(e, ...t) {
  $ ? $.emit(e, ...t) : Ke || Z.push({ event: e, args: t });
}
function Ft(e, t) {
  var n, o;
  $ = e, $ ? ($.enabled = !0, Z.forEach(({ event: s, args: r }) => $.emit(s, ...r)), Z = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((o = (n = window.navigator) == null ? void 0 : n.userAgent) != null && o.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((r) => {
    Ft(r, t);
  }), setTimeout(() => {
    $ || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, Ke = !0, Z = []);
  }, 3e3)) : (Ke = !0, Z = []);
}
const cs = /* @__PURE__ */ ls(
  "component:updated"
  /* COMPONENT_UPDATED */
);
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function ls(e) {
  return (t) => {
    is(
      e,
      t.appContext.app,
      t.uid,
      t.parent ? t.parent.uid : void 0,
      t
    );
  };
}
let y = null, Lt = null;
function ut(e) {
  const t = y;
  return y = e, Lt = e && e.type.__scopeId || null, t;
}
function as(e, t = y, n) {
  if (!t || e._n)
    return e;
  const o = (...s) => {
    o._d && dt(-1);
    const r = ut(t);
    let c;
    try {
      c = e(...s);
    } finally {
      ut(r), o._d && dt(1);
    }
    return process.env.NODE_ENV !== "production" && cs(t), c;
  };
  return o._n = !0, o._c = !0, o._d = !0, o;
}
const us = (e) => e.__isTeleport;
function Ht(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, Ht(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Kt(e, t) {
  return x(e) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    F({ name: e.name }, t, { setup: e })
  ) : e;
}
Ee().requestIdleCallback;
Ee().cancelIdleCallback;
const fs = (e) => !!e.type.__asyncLoader, Wt = "components";
function Ut(e, t) {
  return Yt(Wt, e, !0, t) || e;
}
const Bt = Symbol.for("v-ndc");
function ft(e) {
  return S(e) ? Yt(Wt, e, !1) || e : e || Bt;
}
function Yt(e, t, n = !0, o = !1) {
  const s = y || et;
  if (s) {
    const r = s.type;
    {
      const l = tt(
        r,
        !1
      );
      if (l && (l === t || l === he(t) || l === me(he(t))))
        return r;
    }
    const c = (
      // local registration
      // check instance[type] first which is resolved for options API
      pt(s[e] || r[e], t) || // global registration
      pt(s.appContext[e], t)
    );
    return !c && o ? r : (process.env.NODE_ENV !== "production" && n && !c && V(`Failed to resolve ${e.slice(0, -1)}: ${t}
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.`), c);
  } else process.env.NODE_ENV !== "production" && V(
    `resolve${me(e.slice(0, -1))} can only be used in render() or setup().`
  );
}
function pt(e, t) {
  return e && (e[t] || e[he(t)] || e[me(he(t))]);
}
function fe(e, t, n, o) {
  let s;
  const r = n, c = _(e);
  if (c || S(e)) {
    const l = c && Xe(e);
    let a = !1;
    l && (a = !O(e), e = Ne(e)), s = new Array(e.length);
    for (let f = 0, p = e.length; f < p; f++)
      s[f] = t(
        a ? C(e[f]) : e[f],
        f,
        void 0,
        r
      );
  } else if (typeof e == "number") {
    process.env.NODE_ENV !== "production" && !Number.isInteger(e) && V(`The v-for range expect an integer value but got ${e}.`), s = new Array(e);
    for (let l = 0; l < e; l++)
      s[l] = t(l + 1, l, void 0, r);
  } else if (E(e))
    if (e[Symbol.iterator])
      s = Array.from(
        e,
        (l, a) => t(l, a, void 0, r)
      );
    else {
      const l = Object.keys(e);
      s = new Array(l.length);
      for (let a = 0, f = l.length; a < f; a++) {
        const p = l[a];
        s[a] = t(e[p], p, a, r);
      }
    }
  else
    s = [];
  return s;
}
function ps(e, t, n = {}, o, s) {
  if (y.ce || y.parent && fs(y.parent) && y.parent.ce)
    return n.name = t, g(), U(
      R,
      null,
      [Se("slot", n, o)],
      64
    );
  let r = e[t];
  process.env.NODE_ENV !== "production" && r && r.length > 1 && (V(
    "SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template."
  ), r = () => []), r && r._c && (r._d = !1), g();
  const c = r && qt(r(n)), l = n.key || // slot content array of a dynamic conditional slot may have a branch
  // key attached in the `createSlots` helper, respect that
  c && c.key, a = U(
    R,
    {
      key: (l && !H(l) ? l : `_${t}`) + // #7256 force differentiate fallback content from actual content
      ""
    },
    c || [],
    c && e._ === 1 ? 64 : -2
  );
  return a.scopeId && (a.slotScopeIds = [a.scopeId + "-s"]), r && r._c && (r._d = !0), a;
}
function qt(e) {
  return e.some((t) => Xt(t) ? !(t.type === ye || t.type === R && !qt(t.children)) : !0) ? e : null;
}
const ds = {};
process.env.NODE_ENV !== "production" && (ds.ownKeys = (e) => (V(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
const hs = {}, Jt = (e) => Object.getPrototypeOf(e) === hs, ms = (e) => e.__isSuspense, R = Symbol.for("v-fgt"), gs = Symbol.for("v-txt"), ye = Symbol.for("v-cmt"), pe = [];
let N = null;
function g(e = !1) {
  pe.push(N = e ? null : []);
}
function _s() {
  pe.pop(), N = pe[pe.length - 1] || null;
}
let le = 1;
function dt(e, t = !1) {
  le += e, e < 0 && N && t && (N.hasOnce = !0);
}
function Gt(e) {
  return e.dynamicChildren = le > 0 ? N || un : null, _s(), le > 0 && N && N.push(e), e;
}
function w(e, t, n, o, s, r) {
  return Gt(
    oe(
      e,
      t,
      n,
      o,
      s,
      r,
      !0
    )
  );
}
function U(e, t, n, o, s) {
  return Gt(
    Se(
      e,
      t,
      n,
      o,
      s,
      !0
    )
  );
}
function Xt(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
const bs = (...e) => Zt(
  ...e
), Qt = ({ key: e }) => e ?? null, de = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? S(e) || P(e) || x(e) ? { i: y, r: e, k: t, f: !!n } : e : null);
function oe(e, t = null, n = null, o = 0, s = null, r = e === R ? 0 : 1, c = !1, l = !1) {
  const a = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && Qt(t),
    ref: t && de(t),
    scopeId: Lt,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: r,
    patchFlag: o,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: y
  };
  return l ? (Ze(a, n), r & 128 && e.normalize(a)) : n && (a.shapeFlag |= S(n) ? 8 : 16), process.env.NODE_ENV !== "production" && a.key !== a.key && V("VNode created with invalid key (NaN). VNode type:", a.type), le > 0 && // avoid a block node from tracking itself
  !c && // has current parent block
  N && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (a.patchFlag > 0 || r & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  a.patchFlag !== 32 && N.push(a), a;
}
const Se = process.env.NODE_ENV !== "production" ? bs : Zt;
function Zt(e, t = null, n = null, o = 0, s = null, r = !1) {
  if ((!e || e === Bt) && (process.env.NODE_ENV !== "production" && !e && V(`Invalid vnode type when creating vnode: ${e}.`), e = ye), Xt(e)) {
    const l = ve(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && Ze(l, n), le > 0 && !r && N && (l.shapeFlag & 6 ? N[N.indexOf(e)] = l : N.push(l)), l.patchFlag = -2, l;
  }
  if (on(e) && (e = e.__vccOpts), t) {
    t = ys(t);
    let { class: l, style: a } = t;
    l && !S(l) && (t.class = A(l)), E(a) && (ge(a) && !_(a) && (a = F({}, a)), t.style = we(a));
  }
  const c = S(e) ? 1 : ms(e) ? 128 : us(e) ? 64 : E(e) ? 4 : x(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && c & 4 && ge(e) && (e = h(e), V(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), oe(
    e,
    t,
    n,
    o,
    s,
    c,
    r,
    !0
  );
}
function ys(e) {
  return e ? ge(e) || Jt(e) ? F({}, e) : e : null;
}
function ve(e, t, n = !1, o = !1) {
  const { props: s, ref: r, patchFlag: c, children: l, transition: a } = e, f = t ? Ue(s || {}, t) : s, p = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: f,
    key: f && Qt(f),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && r ? _(r) ? r.concat(de(t)) : [r, de(t)] : de(t)
    ) : r,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && c === -1 && _(l) ? l.map(en) : l,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== R ? c === -1 ? 16 : c | 16 : c,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: a,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && ve(e.ssContent),
    ssFallback: e.ssFallback && ve(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return a && o && Ht(
    p,
    a.clone(p)
  ), p;
}
function en(e) {
  const t = ve(e);
  return _(e.children) && (t.children = e.children.map(en)), t;
}
function We(e = " ", t = 0) {
  return Se(gs, null, e, t);
}
function tn(e = "", t = !1) {
  return t ? (g(), U(ye, null, e)) : Se(ye, null, e);
}
function Ze(e, t) {
  let n = 0;
  const { shapeFlag: o } = e;
  if (t == null)
    t = null;
  else if (_(t))
    n = 16;
  else if (typeof t == "object")
    if (o & 65) {
      const s = t.default;
      s && (s._c && (s._d = !1), Ze(e, s()), s._c && (s._d = !0));
      return;
    } else {
      n = 32;
      const s = t._;
      !s && !Jt(t) ? t._ctx = y : s === 3 && y && (y.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else x(t) ? (t = { default: t, _ctx: y }, n = 32) : (t = String(t), o & 64 ? (n = 16, t = [We(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function Ue(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    for (const s in o)
      if (s === "class")
        t.class !== o.class && (t.class = A([t.class, o.class]));
      else if (s === "style")
        t.style = we([t.style, o.style]);
      else if (fn(s)) {
        const r = t[s], c = o[s];
        c && r !== c && !(_(r) && r.includes(c)) && (t[s] = r ? [].concat(r, c) : c);
      } else s !== "" && (t[s] = o[s]);
  }
  return t;
}
let et = null;
const vs = () => et || y;
{
  const e = Ee(), t = (n, o) => {
    let s;
    return (s = e[n]) || (s = e[n] = []), s.push(o), (r) => {
      s.length > 1 ? s.forEach((c) => c(r)) : s[0](r);
    };
  };
  t(
    "__VUE_INSTANCE_SETTERS__",
    (n) => et = n
  ), t(
    "__VUE_SSR_SETTERS__",
    (n) => nn = n
  );
}
let nn = !1;
process.env.NODE_ENV;
const Cs = /(?:^|[-_])(\w)/g, Es = (e) => e.replace(Cs, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function tt(e, t = !0) {
  return x(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function sn(e, t, n = !1) {
  let o = tt(t);
  if (!o && t.__file) {
    const s = t.__file.match(/([^/\\]+)\.\w+$/);
    s && (o = s[1]);
  }
  if (!o && e && e.parent) {
    const s = (r) => {
      for (const c in r)
        if (r[c] === t)
          return c;
    };
    o = s(
      e.components || e.parent.type.components
    ) || s(e.appContext.components);
  }
  return o ? Es(o) : n ? "App" : "Anonymous";
}
function on(e) {
  return x(e) && "__vccOpts" in e;
}
const ee = (e, t) => {
  const n = Kn(e, t, nn);
  if (process.env.NODE_ENV !== "production") {
    const o = vs();
    o && o.appContext.config.warnRecursiveComputed && (n._warnRecursive = !0);
  }
  return n;
};
function ws() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, o = { style: "color:#eb2f96" }, s = {
    __vue_custom_formatter: !0,
    header(u) {
      return E(u) ? u.__isVue ? ["div", e, "VueInstance"] : P(u) ? [
        "div",
        {},
        ["span", e, p(u)],
        "<",
        // avoid debugger accessing value affecting behavior
        l("_value" in u ? u._value : u),
        ">"
      ] : Xe(u) ? [
        "div",
        {},
        ["span", e, O(u) ? "ShallowReactive" : "Reactive"],
        "<",
        l(u),
        `>${L(u) ? " (readonly)" : ""}`
      ] : L(u) ? [
        "div",
        {},
        ["span", e, O(u) ? "ShallowReadonly" : "Readonly"],
        "<",
        l(u),
        ">"
      ] : null : null;
    },
    hasBody(u) {
      return u && u.__isVue;
    },
    body(u) {
      if (u && u.__isVue)
        return [
          "div",
          {},
          ...r(u.$)
        ];
    }
  };
  function r(u) {
    const d = [];
    u.type.props && u.props && d.push(c("props", h(u.props))), u.setupState !== ze && d.push(c("setup", u.setupState)), u.data !== ze && d.push(c("data", h(u.data)));
    const b = a(u, "computed");
    b && d.push(c("computed", b));
    const T = a(u, "inject");
    return T && d.push(c("injected", T)), d.push([
      "div",
      {},
      [
        "span",
        {
          style: o.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: u }]
    ]), d;
  }
  function c(u, d) {
    return d = F({}, d), Object.keys(d).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        u
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(d).map((b) => [
          "div",
          {},
          ["span", o, b + ": "],
          l(d[b], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function l(u, d = !0) {
    return typeof u == "number" ? ["span", t, u] : typeof u == "string" ? ["span", n, JSON.stringify(u)] : typeof u == "boolean" ? ["span", o, u] : E(u) ? ["object", { object: d ? h(u) : u }] : ["span", n, String(u)];
  }
  function a(u, d) {
    const b = u.type;
    if (x(b))
      return;
    const T = {};
    for (const X in u.ctx)
      f(b, X, d) && (T[X] = u.ctx[X]);
    return T;
  }
  function f(u, d, b) {
    const T = u[b];
    if (_(T) && T.includes(d) || E(T) && d in T || u.extends && f(u.extends, d, b) || u.mixins && u.mixins.some((X) => f(X, d, b)))
      return !0;
  }
  function p(u) {
    return O(u) ? "ShallowRef" : u.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(s) : window.devtoolsFormatters = [s];
}
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* vue v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function Ns() {
  ws();
}
process.env.NODE_ENV !== "production" && Ns();
const Ss = ["avif", "webp", "png", "jpg"];
function Ds({ url: e }, t) {
  const n = e.split(".").pop(), o = t ?? Ss, s = o.find((r) => r === n);
  return s && { ext: s, priority: o.indexOf(s) };
}
function Os(e, t) {
  return !e || !t ? e : e.replace(/\{\{\s*(\w+)\s*\}\}/g, (n, o) => o in t ? t[o] : `{{${o}}}`);
}
const Rs = { key: 0 }, Ts = { key: 0 }, Vs = ["type", "srcset", "sizes"], xs = ["src", "alt", "sizes"], ks = ["src", "alt", "sizes"], js = { key: 1 }, Is = ["type", "srcset", "sizes"], zs = ["src", "alt", "sizes"], $s = ["src", "alt", "sizes"], cr = /* @__PURE__ */ Kt({
  __name: "CrystallizeImage",
  props: {
    image: {},
    sizes: {},
    imgClass: { type: [String, Number, null, Boolean, Array, Object] },
    hideCaption: { type: Boolean }
  },
  setup(e) {
    const t = e, n = ee(() => {
      var s, r, c, l;
      const o = (r = (s = t.image) == null ? void 0 : s.variants) == null ? void 0 : r.reduce((a, f) => {
        const p = Ds(f);
        if (p) {
          const { ext: u, priority: d } = p, b = `image/${u === "jpg" ? "jpeg" : u}`;
          a[b] || (a[b] = { priority: d, srcset: [] }), a[b].srcset.push(`${f.url} ${f.width}w`);
        }
        return a;
      }, {});
      return (l = (c = t.image) == null ? void 0 : c.url) != null && l.endsWith(".svg") && o && (o["image/svg+xml"] = { priority: -1, srcset: [t.image.url] }), Object.entries(o ?? {}).sort(([, a], [, f]) => a.priority - f.priority);
    });
    return (o, s) => {
      var c, l, a, f;
      const r = Ut("CrystallizeRichText");
      return o.image && !o.hideCaption && ((a = (l = (c = o.image) == null ? void 0 : c.caption) == null ? void 0 : l.json) != null && a.length) ? (g(), w("figure", Rs, [
        n.value.length > 0 ? (g(), w("picture", Ts, [
          (g(!0), w(R, null, fe(n.value, ([p, { srcset: u }]) => (g(), w("source", {
            key: p,
            type: p,
            srcset: u.join(", "),
            sizes: o.sizes
          }, null, 8, Vs))), 128)),
          oe("img", {
            src: o.image.url,
            alt: o.image.altText ?? "",
            sizes: o.sizes,
            class: A(o.imgClass)
          }, null, 10, xs)
        ])) : (g(), w("img", {
          key: 1,
          src: o.image.url,
          alt: o.image.altText ?? "",
          sizes: o.sizes,
          class: A(o.imgClass)
        }, null, 10, ks)),
        oe("figcaption", null, [
          (g(!0), w(R, null, fe(o.image.caption.json, (p, u) => (g(), U(r, {
            key: u,
            block: p
          }, null, 8, ["block"]))), 128)),
          ps(o.$slots, "meta", {
            meta: ((f = o.image) == null ? void 0 : f.meta) ?? []
          })
        ])
      ])) : o.image && n.value.length > 0 ? (g(), w("picture", js, [
        (g(!0), w(R, null, fe(n.value, ([p, { srcset: u }]) => (g(), w("source", {
          key: p,
          type: p,
          srcset: u.join(", "),
          sizes: o.sizes
        }, null, 8, Is))), 128)),
        oe("img", {
          src: o.image.url,
          alt: o.image.altText ?? "",
          sizes: o.sizes,
          class: A(o.imgClass)
        }, null, 10, zs)
      ])) : o.image ? (g(), w("img", {
        key: 2,
        src: o.image.url,
        alt: o.image.altText ?? "",
        sizes: o.sizes,
        class: A(o.imgClass)
      }, null, 10, $s)) : tn("", !0);
    };
  }
}), lr = /* @__PURE__ */ Kt({
  __name: "CrystallizeRichText",
  props: {
    block: {},
    variables: {}
  },
  setup(e) {
    const t = e, n = ee(() => {
      switch (t.block.type) {
        // The type is named the same as the tag
        case "table":
        case "span":
        case "strong":
        case "div":
        case "code":
          return t.block.type;
        // The type is named _almost_ the same as the tag
        case "heading1":
        case "heading2":
        case "heading3":
        case "heading4":
        case "heading5":
        case "heading6":
          return t.block.type.replace("heading", "h");
        // Differs with kind
        case "quote":
          return t.block.kind === "block" ? "blockquote" : "q";
        // Everything else
        case "link":
          return "a";
        case "unordered-list":
        case "list":
          return "ul";
        case "ordered-list":
          return "ol";
        case "list-item":
          return "li";
        case "preformatted":
          return "pre";
        case "underlined":
          return "u";
        case "emphasized":
          return "em";
        case "line-break":
          return "br";
        case "deleted":
          return "del";
        case "inserted":
          return "ins";
        case "subscripted":
          return "sub";
        case "superscripted":
          return "sup";
        case "horizontal-line":
          return "hr";
        case "table-row":
          return "tr";
        case "table-cell":
          return "td";
        case "table-head-cell":
          return "th";
        case "paragraph":
          return "p";
        default: {
          const { type: c, kind: l } = t.block;
          return c && console.warn(`Unknown block type: ${c}`, t.block), l === "inline" ? null : "div";
        }
      }
    }), o = ee(() => typeof n.value == "string" && ["hr", "br"].includes(n.value)), s = ee(() => {
      var c;
      return !t.block.textContent && !((c = t.block.children) != null && c.length);
    }), r = ee(() => Os(t.block.textContent, t.variables));
    return (c, l) => {
      const a = Ut("CrystallizeRichText", !0);
      return !n.value && r.value ? (g(), w(R, { key: 0 }, [
        We(Ae(r.value), 1)
      ], 64)) : s.value && o.value ? (g(), U(ft(n.value), it(Ue({ key: 1 }, c.block.metadata ?? {})), null, 16)) : s.value ? tn("", !0) : (g(), U(ft(n.value), it(Ue({ key: 2 }, c.block.metadata ?? {})), {
        default: as(() => [
          r.value ? (g(), w(R, { key: 0 }, [
            We(Ae(r.value), 1)
          ], 64)) : (g(!0), w(R, { key: 1 }, fe(c.block.children, (f, p) => (g(), U(a, {
            key: p,
            block: f,
            variables: c.variables
          }, null, 8, ["block", "variables"]))), 128))
        ]),
        _: 1
      }, 16));
    };
  }
}), As = i.boolean(), Ms = As, Ps = i.object({ value: Ms }), Fs = Ps, Ls = i.object({
  type: i.literal("boolean"),
  content: i.nullish(Fs)
}), Hs = Ls, Ks = i.pipe(
  // From Crystallize, this is always a string, but since this schema contains an internal transform to a Date, we support dates and numbers as inputs as well to make parsing idempotent.
  i.union([
    i.string(),
    i.date(),
    i.number()
  ]),
  i.transform((e) => new Date(e))
), Ws = Ks, Us = i.object({
  datetime: Ws
}), Bs = Us, Ys = i.object({
  type: i.literal("datetime"),
  content: i.nullish(Bs)
}), qs = Ys, Js = i.union([
  i.object({
    // TODO: If possible, improve this schema to be more specific
    metadata: i.nullish(i.unknown()),
    type: i.nullish(
      i.picklist([
        "paragraph",
        "strong",
        "line-break",
        "unordered-list",
        "ordered-list",
        "list",
        "list-item",
        "quote",
        "preformatted",
        "code",
        "underlined",
        "emphasized",
        "div",
        "span",
        "heading1",
        "heading2",
        "heading3",
        "heading4",
        "heading5",
        "heading6",
        "deleted",
        "inserted",
        "subscripted",
        "superscripted",
        "horizontal-line",
        "table",
        "table-row",
        "table-cell",
        "table-head-cell"
      ])
    )
  }),
  i.object({
    type: i.literal("link"),
    metadata: i.nullish(i.object({
      href: i.nullish(i.string()),
      target: i.nullish(i.string()),
      rel: i.nullish(i.string())
    }))
  })
]), nt = i.intersect([
  Js,
  i.object({
    kind: i.picklist(["block", "inline"]),
    children: i.nullish(i.array(i.lazy(() => nt))),
    textContent: i.nullish(i.string())
  })
]), Gs = i.array(nt), ar = Gs, Xs = i.object({ json: i.array(nt) }), st = Xs, Qs = i.object({
  type: i.literal("richText"),
  content: i.nullish(st)
}), Zs = Qs, eo = i.object({
  url: i.pipe(i.string(), i.url()),
  altText: i.nullish(i.string()),
  caption: i.nullish(st),
  meta: i.nullish(i.array(i.object({
    key: i.nullish(i.string()),
    value: i.nullish(i.string())
  }))),
  variants: i.nullish(
    i.array(i.object({
      url: i.pipe(i.string(), i.url()),
      width: i.number()
    }))
  )
}), to = eo, no = i.array(to), rn = no, so = i.object({
  images: rn
}), oo = so, ro = i.object({
  type: i.literal("images"),
  content: i.nullish(oo)
}), io = ro, co = i.array(
  i.object({
    id: i.string(),
    name: i.string(),
    path: i.string()
  })
), lo = co, ao = i.array(
  i.object({
    sku: i.string(),
    name: i.string()
  })
), uo = ao, fo = i.union([
  i.object({
    productVariants: i.nullish(i.never()),
    items: lo
  }),
  i.object({
    items: i.nullish(i.never()),
    productVariants: uo
  })
]), po = fo, ho = i.object({
  type: i.literal("itemRelations"),
  content: i.nullish(po)
}), mo = ho, go = i.number(), _o = go, bo = i.object({ number: _o }), yo = bo, vo = i.object({
  type: i.literal("numeric"),
  content: i.nullish(yo)
}), Co = vo, Eo = i.string(), wo = Eo, No = i.object({ text: wo }), cn = No, So = i.object({
  type: i.literal("singleLine"),
  content: i.nullish(cn)
}), Do = So, Oo = i.object({
  title: i.nullish(cn),
  body: i.nullish(st),
  images: i.nullish(rn)
}), Ro = Oo, To = i.array(Ro), Vo = To, xo = i.object({
  paragraphs: Vo
}), ko = xo, jo = i.object({
  type: i.literal("paragraphCollection"),
  content: i.nullish(ko)
}), Io = jo, zo = i.array(i.object({
  key: i.string(),
  value: i.string()
})), $o = zo, Ao = i.object({
  options: $o
}), Mo = Ao, Po = i.object({
  type: i.literal("selection"),
  content: i.nullish(Mo)
}), Fo = Po, Lo = i.union([
  Hs,
  Co,
  Do,
  qs,
  Fo,
  io,
  Zs,
  Io,
  mo
]), De = Lo, Ho = i.object({ id: i.string() }), Oe = Ho, Ko = i.array(
  i.array(
    i.intersect([
      Oe,
      i.union([
        De,
        // eslint-disable-next-line ts/no-use-before-define
        i.lazy(() => Re)
      ])
    ])
  )
), Wo = Ko, Uo = i.object({
  chunks: Wo
}), Bo = Uo, Yo = i.object({
  type: i.literal("contentChunk"),
  content: i.nullish(Bo)
}), ot = Yo, qo = i.array(
  i.intersect([
    Oe,
    i.union([
      De,
      ot,
      // eslint-disable-next-line ts/no-use-before-define
      i.lazy(() => Re),
      // eslint-disable-next-line ts/no-use-before-define
      i.lazy(() => ln)
    ])
  ])
), Jo = qo, Go = i.object({
  components: Jo
}), Xo = Go, Qo = i.object({
  type: i.literal("piece"),
  content: i.nullish(Xo)
}), Re = Qo, Zo = i.array(
  i.intersect([
    Oe,
    i.union([
      De,
      ot,
      i.lazy(() => Re)
    ])
  ])
), er = Zo, tr = i.object({
  selectedComponents: er
}), nr = tr, sr = i.object({
  type: i.literal("componentMultipleChoice"),
  content: i.nullish(nr)
}), ln = sr, or = i.union([
  De,
  ot,
  Re,
  ln
]), rr = or, ir = i.intersect([
  Oe,
  rr
]), ur = ir;
export {
  cr as CrystallizeImage,
  lr as CrystallizeRichText,
  De as baseComponent,
  Hs as booleanComponent,
  Fs as booleanContent,
  Ms as booleanData,
  rr as componentContentSchema,
  ur as componentSchema,
  ot as contentChunkComponent,
  Bo as contentChunkContent,
  Wo as contentChunkData,
  qs as datetimeComponent,
  Bs as datetimeContent,
  Ws as datetimeData,
  Ds as getExtAndPriority,
  Oe as identifiable,
  to as image,
  io as imagesComponent,
  oo as imagesContent,
  rn as imagesData,
  Os as interpolate,
  mo as itemRelationsComponent,
  po as itemRelationsContent,
  ln as multipleChoiceComponent,
  nr as multipleChoiceContent,
  er as multipleChoiceData,
  Co as numericComponent,
  yo as numericContent,
  _o as numericData,
  Ro as paragraph,
  Io as paragraphCollectionComponent,
  ko as paragraphCollectionContent,
  Vo as paragraphCollectionData,
  Re as pieceComponent,
  Xo as pieceContent,
  Jo as pieceData,
  lo as relatedDocumentsData,
  uo as relatedProductVariantsData,
  Zs as richTextComponent,
  st as richTextContent,
  ar as richTextData,
  Fo as selectionComponent,
  Mo as selectionContent,
  $o as selectionData,
  Do as singleLineComponent,
  cn as singleLineContent,
  wo as singleLineData
};
